const aboutText = {
    introText: "Frontend developer with 1 year of full-time experience.", 
    currentFocussees: "I dabble in cloud-technologies and backend development through personal projects and setting up minecraft servers on cloud services.",
}

export default aboutText